import { FunctionComponent, useCallback } from 'react';
import { TableColProps } from '../../components/table';

import { InstallationSite } from '../../interfaces/InstallationSite';
import { InstallationSitesService, TestTaskService } from '../../services';
import { useAddError } from '../../context/error';
import { useNavigate } from 'react-router-dom';
import TableWithSearch, { OnDataParams, OnSearchParams } from '../../views/TableWithSearchView';
import { useAuth } from '../../context/auth';
import { get } from 'lodash';

const columns: TableColProps<InstallationSite>[] = [
  {
    title: 'Name',
    values: 'name',
    key: 'name',
    type: 'string',
    filterable: (addError, limit, page, query) =>
      (query && query.length > 0
        ? InstallationSitesService(addError)
            .search(query)
            .then((res) => res.items)
        : TestTaskService(addError)
            .list(limit, page)
            .then((res) => res.items)
      ).then((i) => i.map((v) => ({ value: v.name, title: v.name }))),
  },
];

const List: FunctionComponent = () => {
  const navigate = useNavigate();
  const addError = useAddError();
  const auth = useAuth();

  const onNew = useCallback(() => {
    navigate('new');
  }, [navigate]);

  if (!auth || !auth.user) {
    return null;
  }

  return (
    <TableWithSearch
      title="Aufstellorte"
      to="/settings"
      defaultLimit={get(auth, 'user.itemsPerPage', 25)}
      columns={columns}
      onData={function ({ filter, limit, page }: OnDataParams<InstallationSite>) {
        return InstallationSitesService(addError).list<InstallationSite>(limit, page, filter);
      }}
      onSearch={function ({ limit, page, term }: OnSearchParams) {
        return InstallationSitesService(addError).search<InstallationSite>(term, limit, page);
      }}
      onNew={onNew}
    />
  );
};

export default List;
